import { useEffect, useState } from "react";
import { api, type AuditEventRow } from "../api.js";
import { useLocale } from "../ui.js";

export function AuditPanel({ token }: { token: string }) {
  const { tr } = useLocale();
  const [events, setEvents] = useState<AuditEventRow[] | null>(null);

  useEffect(() => {
    let live = true;
    void api.adminAudit(token).then((res) => {
      if (live) setEvents(res.ok && res.data ? res.data.events : []);
    });
    return () => {
      live = false;
    };
  }, [token]);

  return (
    <section className="panel-card">
      <h2>{tr("audit")}</h2>
      <p className="section-desc">{tr("owner")} · append-only</p>
      {events === null ? (
        <p className="muted">{tr("loading")}</p>
      ) : events.length === 0 ? (
        <p className="muted">{tr("emptyList")}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Action</th>
              <th>Actor</th>
              <th>Outcome</th>
            </tr>
          </thead>
          <tbody>
            {events.map((e, i) => (
              <tr key={`${e.createdAt}-${i}`}>
                <td className="muted">{new Date(e.createdAt).toLocaleString()}</td>
                <td>
                  {e.domain}.{e.action}
                </td>
                <td>{e.actor}</td>
                <td>
                  <span className={`pill ${e.outcome === "allowed" ? "active" : "blocked"}`}>{e.outcome}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
